import { FeedTypes } from './feed';

export enum FeedFiltersType {
	FAVOURITE_TEAM = FeedTypes.FAVOURITE_TEAM,
	FOLLOWED_TEAMS = FeedTypes.FOLLOWED_TEAMS,
	SUGGESTED_FEED = FeedTypes.SUGGESTED_FEED
}
